export default __webpack_public_path__ + "static/media/unlocked.b9cca8ae.svg";